import { render, staticRenderFns } from "./v0.vue?vue&type=template&id=67860f08&scoped=true&"
import script from "./v0.vue?vue&type=script&lang=js&"
export * from "./v0.vue?vue&type=script&lang=js&"
import style0 from "./v0.vue?vue&type=style&index=0&id=67860f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67860f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67860f08')) {
      api.createRecord('67860f08', component.options)
    } else {
      api.reload('67860f08', component.options)
    }
    module.hot.accept("./v0.vue?vue&type=template&id=67860f08&scoped=true&", function () {
      api.rerender('67860f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin-dashboard/v0.vue"
export default component.exports